import { jsx as _jsx } from "react/jsx-runtime";
const FilledTrashIcon = (props) => {
    return (_jsx("svg", Object.assign({ width: "100%", height: "100%", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("g", Object.assign({ id: "Icon=Trashcan full" }, { children: _jsx("path", { id: "Vector", d: "M8.99951 3V4H3.99951V6H4.99951V19C4.99951 19.5304 5.21023 20.0391 5.5853 20.4142C5.96037 20.7893 6.46908 21 6.99951 21H16.9995C17.5299 21 18.0387 20.7893 18.4137 20.4142C18.7888 20.0391 18.9995 19.5304 18.9995 19V6H19.9995V4H14.9995V3H8.99951ZM8.99951 8H10.9995V17H8.99951V8ZM12.9995 8H14.9995V17H12.9995V8Z", fill: props.color }) })) })));
};
FilledTrashIcon.defaultProps = {
    color: 'white',
};
export default FilledTrashIcon;
